import { render, staticRenderFns } from "./AudioTool.vue?vue&type=template&id=bf4c33d4&scoped=true"
import script from "./index.js?vue&type=script&lang=js&external"
export * from "./index.js?vue&type=script&lang=js&external"
import style0 from "./AudioTool.vue?vue&type=style&index=0&id=bf4c33d4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf4c33d4",
  null
  
)

export default component.exports